import tw, { styled } from "twin.macro";
import InputBase from 'styles/basic/InputBase';
import { DownloadIcon } from 'styles/components/Icons';

export const StyledFileContainer = styled(InputBase).attrs(() => ({ as: 'label' }))`
    ${tw`flex flex-row cursor-pointer hocus:bg-card-secondary`}
`;

export const StyledFileLabel = styled.div`
    ${tw`flex items-center justify-center flex-1 -mb-px text-base`}
`;

export const StyledActionIcon = styled(DownloadIcon).attrs(() => ({ size: 32 }))`
    ${tw`p-1 -m-1 rounded-lg cursor-pointer hover:bg-opacity-75`}
`;